import { GENDER_TYPES, VARIABLE_BIAS_GENDER_ATTRIBUTE } from 'constants/variableBias';

export interface VariableBiasFacetValue {
  value: string;
  score: number;
}

export interface VariableBiasAttribute {
  solrName: string;
  facetValues?: VariableBiasFacetValue[];
}

export interface VariableBiasResponse {
  attributes?: VariableBiasAttribute[];
}

const FALLBACK_TAB = GENDER_TYPES.WOMEN;

export const resolveDefaultTab = (response?: VariableBiasResponse | null): string => {
  const genderAttr = response?.attributes?.find(a => a.solrName === VARIABLE_BIAS_GENDER_ATTRIBUTE);

  if (!genderAttr?.facetValues?.length) {
    return FALLBACK_TAB;
  }

  const scores = Object.fromEntries(genderAttr.facetValues.map(v => [v.value.toLowerCase(), v.score]));
  const women = scores['women'] ?? 0;
  const men = scores['men'] ?? 0;
  const kids = (scores['boys'] ?? 0) + (scores['girls'] ?? 0);

  const max = Math.max(women, men, kids);

  if (max === 0) {
    return FALLBACK_TAB;
  }

  if ([women, men, kids].filter(s => s === max).length > 1) {
    return FALLBACK_TAB;
  }

  if (women === max) {
    return GENDER_TYPES.WOMEN;
  }

  if (men === max) {
    return GENDER_TYPES.MEN;
  }

  return GENDER_TYPES.KIDS;
};
